import React from "react";
import {Grid} from 'semantic-ui-react'


function Footer({tags, data, option}) {

    const [overrideVisible, setOverrideVisible] = React.useState({'visible': true});
    
    var yearid;
    var monthid;
    var dayid;
    var hourid;
    var minid;
    var secid;
    var alarmid;
    var totalovr;

    React.useEffect(() => {
        let interval = setInterval(setOverrideVisiblity, 1000);
        return() => clearInterval(interval);
    }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

    const setOverrideVisiblity = () => {
        setOverrideVisible({...overrideVisible, 'visible': !overrideVisible.visible});
    }

    // update 250224, datetime 태그 이름 변경
    const getId = (tags) => {
        if(tags.length > 0 ){
            for(let i =0; i < tags.length; i++){
                if(tags[i].name.includes('DAY_INFO')){
                    dayid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('MONTH_INFO')){
                    monthid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('YEAR_INFO')){
                    yearid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('HOUR_INFO')){
                    hourid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('MIN_INFO')){
                    minid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('SEC_INFO')){
                    secid = tags[i].id;
                    continue;
                }else if(tags[i].name.includes('TOTALALARMS')){
                    alarmid = tags[i].id;
                    continue;
                }
            }
        }
    }

    const getTotalOverrides = (tags) => {
        const prefix = tags[0].name.slice(0,4);

        if (prefix  === 'MAIN'){
            totalovr = '0';
        }else if (prefix === 'PSM1'){
            totalovr = '-1';
        }else if (prefix === 'PSM2'){
            totalovr = '-2';
        }else if (prefix === 'PSM3'){
            totalovr = '-3';
        }else if (prefix === 'PSM4'){
            totalovr = '-4';
        }else if (prefix === 'PSM5'){
            totalovr = '-5';
        }

    }

    if(tags.length > 0){
        getId(tags);
        getTotalOverrides(tags);
    }

    const styles = {
        metadata: {
            maxWidth: '1200px',
            marginLeft: '20px',
            marginTop: '20px',
            textAlign : 'center'
        },
        row: {
            padding: '2px 0',
        },
        name: {
            color: 'yellow',
            width: '133px',
            textAlign : 'center'
        },
        main_name: {
            color: 'yellow',
            width: '133px',
            textAlign : 'center',
            paddingLeft : '50px'
        },
        footer: {
            position: 'fixed',
            bottom: 0,
            marginLeft: '50px',
            marginTop: '100px'
        },
        div: {
            marginTop: (option === 2) ? '700px' : '0'
        },
        name_2: {
            color: 'yellow'
        },
        name_states: {
            color: 'yellow',
            width: '130px',
            textAlign : 'center',
            marginLeft : '34px', // KHNP
            // marginLeft : '52px',
            justifyContent : 'center'
        }
    };

    const styles2 = {
        metadata: {
            maxWidth: '1200px',
            marginLeft: '20px',
            marginTop: '20px',
            width : '500px'
        },
        row: {
            padding: '2px 0',
        },
        name: {
            color: 'yellow',
            // width: '133px'
        },
        footer: {
            position: 'fixed',
            bottom: 0,
            marginLeft: '50px',
            marginTop: '100px'
        },
        name_2: {
            color: 'yellow', 
            textAlign : 'center'
        }
    };

    const styles_mainfooter = {
        metadata: {
            maxWidth: '1200px',
            marginLeft: '20px',
            marginTop: '20px',
            width : '900px'
        },
        row: {
            padding: '2px 0',
        },
        name: {
            color: 'yellow',
            // width: '133px'
        },
        footer: {
            position: 'fixed',
            bottom: 0,
            marginLeft: '50px',
            marginTop: '100px'
        },
        name_2: {
            color: 'yellow', 
            textAlign : 'center'
        }
    };



    return (
        <>
            { option === 'Plant Overview' ?
                 <div style={styles2.div}>
                    <Grid key={tags} inverted celled style={styles2.metadata}>
                        <Grid.Row columns={1}>
                            {tags.filter(el => el.tag_display_subgroup !== 'MISC').map(s =>
                                <Grid.Column key={s.tag_id} textAlign='center' style={styles2.row}>
                                    <Grid.Row style={styles2.name} textAlign='center'>{s.tag_display_name}</Grid.Row>
                                    <Grid.Row textAlign='center'> {data[s.id]}</Grid.Row>
                                </Grid.Column>
                            )}
                        </Grid.Row>
                    {tags.length > 0 ?
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign='center' style={styles2.row}>
                                <Grid.Row textAlign='center' style={styles2.name_2}>Date</Grid.Row>
                                <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[29141] + '-' + data[29142] + '-' + data[29143]) : ''}</Grid.Row>
                            </Grid.Column>
                            <Grid.Column textAlign='center' style={styles2.row}>
                                <Grid.Row textAlign='center' style={styles2.name_2}>Time</Grid.Row>
                                <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[29138] + ':' + data[29139] + ':' + data[29140]) : ''}</Grid.Row>
                            </Grid.Column>
                            
                        </Grid.Row>
                        : ''}
                    </Grid>
                </div>
                : option === 'MAIN' ?
                <div style={styles_mainfooter.div}>
                    <Grid key={tags} inverted celled style={styles_mainfooter.metadata}>
                        <Grid.Row columns={6}>
                            {tags.filter(el => el.tag_display_subgroup !== 'MISC').map(s =>
                                <Grid.Column key={s.tag_id} textAlign='center' style={styles_mainfooter.row}>
                                    <Grid.Row textAlign = 'center' style={styles_mainfooter.name_2}>{s.tag_display_name}</Grid.Row>
                                    <Grid.Row textAlign='center'> {data[s.id]}</Grid.Row>
                                </Grid.Column>
                            )}
                        </Grid.Row>
                        {tags.length > 0 ?
                            <Grid.Row columns={4}>
                                <Grid.Column textAlign='center' style={styles_mainfooter.row}>
                                    <Grid.Row textAlign='center' style={styles_mainfooter.name_2}>Date</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[29141] + '-' + data[29142] + '-' + data[29143]) : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles_mainfooter.row}>
                                    <Grid.Row textAlign='center' style={styles_mainfooter.name_2}>Time</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[29138] + ':' + data[29139] + ':' + data[29140]) : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles_mainfooter.row}>
                                    <Grid.Row textAlign='center' style={styles_mainfooter.name_2}>Total Alarms</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? data[alarmid] : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles_mainfooter.row}>
                                    <Grid.Row textAlign='center' style={styles_mainfooter.name_2}>Overrides</Grid.Row>
                                    { (typeof data !== 'undefined' && data !== null && data[totalovr] > 0 && overrideVisible.visible) ?
                                    <Grid.Row textAlign='center' style={{color: 'green'}}>{(typeof data !== 'undefined' && data !== null) ? data[totalovr] : ''}</Grid.Row>
                                        :
                                        <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? data[totalovr] : ''}</Grid.Row> }
                                </Grid.Column>
                            </Grid.Row>
                        : ''}
                        </Grid>
                    </div>
                    :

                    <div style={styles.div}>
                        <Grid key={tags} inverted celled style={styles.metadata}>
                        <Grid.Row columns={6}> {/** 241004 marine : C State 삭제  */}
                            {tags.filter(el => el.tag_display_subgroup !== 'MISC').map(s =>
                                <Grid.Column key={s.tag_id} style={styles.row} >
                                    <Grid.Row textAlign='center' style={styles.name_states} >{s.tag_display_name}</Grid.Row>
                                    {/* <Grid.Row textAlign='center'>{s.tag_display_name}</Grid.Row> */}
                                    <Grid.Row textAlign='center'>{data[s.id]}</Grid.Row>
                                </Grid.Column>
                            )}
                        </Grid.Row>
                        {tags.length > 0 ?
                            <Grid.Row columns={4}>
                                <Grid.Column textAlign='center' style={styles.row}>
                                    <Grid.Row textAlign='center' style={styles.name_2}>Date</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[monthid] + '-' + data[dayid] + '-' + data[yearid]) : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles.row}>
                                    <Grid.Row textAlign='center' style={styles.name_2}>Time</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? (data[hourid] + ':' + data[minid] + ':' + data[secid]) : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles.row}>
                                    <Grid.Row textAlign='center' style={styles.name_2}>Total Alarms</Grid.Row>
                                    <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? data[alarmid] : ''}</Grid.Row>
                                </Grid.Column>
                                <Grid.Column textAlign='center' style={styles.row}>
                                    <Grid.Row textAlign='center' style={styles.name_2}>Overrides</Grid.Row>
                                    { (typeof data !== 'undefined' && data !== null && data[totalovr] > 0 && overrideVisible.visible) ?
                                    <Grid.Row textAlign='center' style={{color: 'green'}}>{(typeof data !== 'undefined' && data !== null) ? data[totalovr] : ''}</Grid.Row>
                                        :
                                        <Grid.Row textAlign='center'>{(typeof data !== 'undefined' && data !== null) ? data[totalovr] : ''}</Grid.Row> }
                                </Grid.Column>
                            </Grid.Row>
                        : ''}
                        </Grid>
                    </div>
            }
        </>
    );

}


export default Footer;
